import { ccwpApi } from "@/services";
import { DEBTOREDITVIEW, DEBTORLIST_1 } from "../constant/apiPath";
import { maxPageSize } from "@/Constant";

type DebtorFormRequestType = {
  caseId: string;
  debtorId: string;
  name: string;
  description: string;
  isActive: boolean;
};

const commonParams = {
  Type: "quick search",
  OrderBy: "desc",
  PageNo: 1,
  PageSize: 20,
};

// Define a service using a base URL and expected endpoints
export const DebtorListApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getDebtorList: builder.query<any, any>({
      query: (paramsData) => ({
        url: "Debtor/GetDebtorListByCase",
        method: "GET",
        params: { ...paramsData },
      }),
      providesTags: ["DebtorList"],
    }),
    searchDebtorListData: builder.query<
      any,
      { caseId: string; SearchText?: string }
    >({
      query: ({ caseId, SearchText }) => {
        return {
          url: DEBTORLIST_1 + caseId,
          params: {
            ...commonParams,
            SearchText,
          },
        };
      },
      transformResponse: (response: { results: any[] }) => response.results,
    }),
    getDebtorListData: builder.query<any, any>({
      query: (caseId) => {
        let params = {
          pageSize: maxPageSize,
          pageNumber: 1,
        };
        return {
          url: DEBTORLIST_1 + caseId,
          params: {
            ...params,
          },
        };
      },
      transformResponse: (response: { results: any[] }) => response.results,
      providesTags: ["DebtorList"],
    }),
    disableDebtor: builder.mutation({
      query: (debtorId) => ({
        url: `Debtor/DisableDebtor/${debtorId}`,
        method: "PUT",
      }),
    }),
    createDebtor: builder.mutation({
      query: (data: DebtorFormRequestType) => ({
        url: `Debtor/AddNewDebtor`,
        method: "POST",
        body: data,
      }),
    }),
    updateDebtor: builder.mutation({
      query: (data: DebtorFormRequestType) => ({
        url: `Debtor/UpdateDebtor/${data.debtorId}`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDebtorListQuery,
  useLazySearchDebtorListDataQuery,
  useGetDebtorListDataQuery,
  useDisableDebtorMutation,
  useCreateDebtorMutation,
  useUpdateDebtorMutation,
} = DebtorListApi;

export const debtorEditViewApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getDebtorEditViewApiData: builder.query<any, any>({
      query: (debtorId) => DEBTOREDITVIEW + debtorId,
      //transformResponse: (response: { results: any[] }) => response.results,
      providesTags: ["DebtorEditView"],
    }),
  }),
});
export const { useGetDebtorEditViewApiDataQuery } = debtorEditViewApi;
